import { render, staticRenderFns } from "./Justificativas.vue?vue&type=template&id=92529ea0&"
import script from "./Justificativas.vue?vue&type=script&lang=js&"
export * from "./Justificativas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports